import { createBrowserRouter } from "react-router-dom";
import RootLayoutAdmin from "../components/admin/RootLayoutAdmin";
import RootLayoutDashboardAdmin from "../components/admin/RootLayoutDashboardAdmin";
import HomeAdmin from "../pages/admin/HomeAdmin";
import LoginAdmin from "../pages/admin/LoginAdmin";
import SignupAdmin from "../pages/admin/SignupAdmin";
import ProductsAdmin from "../pages/admin/ProductsAdmin";
import HomeDashboardAdmin from "../pages/admin/HomeDashboardAdmin.js"; // TestDashboard toevoegen
import { checkAuthLoader, tokenLoader } from "../util/admin/authAdmin";
import { action as logoutAction } from "../pages/admin/LogoutAdmin";
import MenusAdmin from "../pages/admin/MenusAdmin.js";
import SettingsAdmin from "../pages/admin/SettingsAdmin.js";
import PickupMomentsAdmin from "../pages/admin/PickupMomentsAdmin.js";
import OrdersAdmin from "../pages/admin/OrdersAdmin.js";
import DiscountsAdmin from "../pages/admin/DiscountsAdmin.js";
import CollectionsAdmin from "../pages/admin/CollectionsAdmin.js";
import NotFound from "../pages/NotFound.js";
import TermsAndConditions from "../pages/TermsAndConditions.js";
import PrivacyPolicy from "../pages/PrivacyPolicy.js";

export const adminRouter = createBrowserRouter([
   {
      path: "/",
      element: <RootLayoutAdmin />,
      children: [
         {
            index: true, // Default child voor "/"
            element: <HomeAdmin />,
         },
         {
            path: "inloggen", // Nested route voor "/login"
            element: <LoginAdmin />,
         },
         {
            path: "registreren", // Nested route voor "/signup"
            element: <SignupAdmin />,
         },
         {
            path: "logout",
            action: logoutAction,
         },
         {
            path: "algemene-voorwaarden",
            element: <TermsAndConditions />,
         },
         {
            path: "privacy",
            element: <PrivacyPolicy />,
         },
      ],
   },
   {
      path: "/dashboard",
      element: <RootLayoutDashboardAdmin />,
      loader: tokenLoader, // Controleert de tokenstatus voor deze routes
      children: [
         {
            index: true, // Default child voor "/"
            element: <HomeDashboardAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'producten',
            element: <ProductsAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'menus',
            element: <MenusAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'instellingen',
            element: <SettingsAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'ophaalmomenten',
            element: <PickupMomentsAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'bestellingen',
            element: <OrdersAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'kortingen',
            element: <DiscountsAdmin />,
            loader: checkAuthLoader
         },
         {
            path: 'collecties',
            element: <CollectionsAdmin />,
            loader: checkAuthLoader
         },
      ],
   },
   {
      path: "*",
      element: <NotFound />
   }
]);
